export * from './animation.interface';
export * from './loading-g.interface';
